import { toast, Bounce } from "react-toastify";

/**
 * Custom hook for displaying toast notifications using react-toastify.
 *
 * Provides preconfigured methods for showing error toasts (and can be extended for other types).
 * Ensures consistent styling, behavior, and reduces duplication across the app.
 *
 * @returns {Object} Toast methods
 * @returns {(message: string) => void} showError - Displays a standardized error toast.
 *
 * @example
 * const { showError } = useToast();
 * showError("Something went wrong.");
 */
const useToast = () => {
    const showError = (message) => {
        toast.error(message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
        });
    };

    return { showError };
};

export default useToast;
